import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Table } from "@/pages/admin/Payments";

export default function Emails() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/emails").then((r) => setRows(r.data));
  useEffect(() => {
    load();
  }, []);
  const retry = (id) => api.post(`/admin/emails/${id}/retry`).then(() => { toast.success("Retry queued"); setTimeout(load, 1500); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div data-testid="admin-emails">
      <PageHead title="Email delivery" />
      <Table head={["Created", "Type", "To", "Subject", "Status", "Attempts", ""]} testid="emails-table">
        {rows.map((e) => (
          <tr key={e.id} className="border-b border-white/5">
            <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{fmtDate(e.created_at)}</td>
            <td className="px-4 py-3">{e.kind.replace(/_/g, " ")}</td>
            <td className="px-4 py-3">{e.to}</td>
            <td className="px-4 py-3 text-slate-300">{e.subject}</td>
            <td className="px-4 py-3"><span className={e.status === "sent" ? "accent-text" : e.status === "failed" ? "text-red-400" : "text-slate-400"}>{e.status}</span>{e.last_error && e.status !== "sent" && <span className="block text-xs text-slate-500">{e.last_error}</span>}</td>
            <td className="px-4 py-3">{e.attempts}</td>
            <td className="px-4 py-3">{["failed", "paused"].includes(e.status) && <button data-testid={`email-retry-${e.id}`} onClick={() => retry(e.id)} className="text-xs accent-text">Retry</button>}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
